
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import McpLanding from '@/components/mcp/McpLanding';
// Public marketing + setup page for the Easy-Peasy.AI MCP server.
// The same /mcp URL doubles as the MCP protocol endpoint: header-matching
// rewrites in next.config.mjs send JSON-RPC / event-stream requests to
// /api/mcp before this page is resolved, so browsers get this page and
// MCP clients get the server.
const McpPage = () => <McpLanding />;
export default McpPage;

    async function __Next_Translate__getStaticProps__1a1052e9142__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/mcp',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1052e9142__ as getStaticProps }
  